var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-teams-workspace-wrapper"},[_c('h6',[_vm._v("Команд нет")]),_c('button',{on:{"click":function($event){return _vm.$emit('changeWorkspace', 'AddTeam')}}},[_vm._v("Добавить команду")])])
}
var staticRenderFns = []

export { render, staticRenderFns }